<div class="heading">
    Upload Documents
</div>

<div class="secondary-text">
    (The documents that you upload need to be clearly legible. Your application is auto saved, you can arrange missing
    documents and LOGIN to begin from same place)
</div>

<div class="pt-3">
    <form (ngSubmit)="onSubmit()">
        <div>
            <p class="form-field-heading">Photograph</p>

            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #photo name="photo"
                               [class.file-disabled]="isVerified(photoVerificationStatus)"
                               (change)="uploadDocument(LoanApplicationDocumentType.PHOTO, $event)"
                               (click)="photo.value=null"
                               appAcceptFormats=".jpg,.jpeg,.png" accept=".jpg,.jpeg,.png" toggleCamera="InSecureFile">
                        <div class="file-browse">
                            <span class="file-browse-txt">Upload your recent passport sized photograph</span>
                            <span class="browse" [class.file-disabled]="isVerified(photoVerificationStatus)"><i
                                    class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.PHOTO"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.photo.isInValid">
                    {{uploadFileFormValidator.photo.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let photo of uploadedFileForm.photo">
                            <span class="file-tag mt-2" [class.file-disabled]="isVerified(photoVerificationStatus)">
                                {{photo.fileName}}&nbsp;
                                <span class="pointer"
                                      (click)="removeFile(LoanApplicationDocumentType.PHOTO,photo.fileId)">
                                &#10005;
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div>
            <p class="form-field-heading">PAN card</p>

            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #pan name="pan"
                               (change)="uploadDocument(LoanApplicationDocumentType.PAN, $event)"
                               (click)="pan.value=null" appAcceptFormats=".jpg,.jpeg,.png" toggleCamera="SecureFile"
                               [class.file-disabled]="isVerified(panVerificationStatus)">
                        <div class="file-browse">
                            <span class="file-browse-txt">Upload a copy of your PAN card</span>
                            <span class="browse" [class.file-disabled]="isVerified(photoVerificationStatus)"><i
                                    class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.PAN"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.pan.isInValid">
                    {{uploadFileFormValidator.pan.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let pan of uploadedFileForm.pan">
                            <span class="file-tag mt-2" [class.file-disabled]="isVerified(panVerificationStatus)">
                                {{pan.fileName}}&nbsp;
                                <span class="pointer" (click)="removeFile(LoanApplicationDocumentType.PAN,pan.fileId)">
                                &#10005;
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>

            </div>
        </div>

        <div>
            <p class="form-field-heading">{{AddressProofTypeModel.getDisplayableDocumentType(uploadedFileForm.addressProofType)}}</p>

            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #address name="address"
                               (change)="uploadDocument(LoanApplicationDocumentType.ADDRESS_PROOF, $event)"
                               (click)="address.value=null" appAcceptFormats=".jpg,.jpeg,.png"
                               [ngClass]="{ 'cursor-normal': uploadedFileForm.address_proof.length > 0 }"
                               [disabled]="uploadedFileForm.addressProofType === AddressProofType.aadhaar &&
                                          uploadedFileForm.address_proof.length > 0"  toggleCamera="SecureFile">
                        <div class="file-browse">
                            <span class="file-browse-txt">Upload a copy of your {{AddressProofTypeModel.getDisplayableDocumentType(uploadedFileForm.addressProofType)}}</span>
                            <span class="browse"><i class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.ADDRESS_PROOF"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.address_proof.isInValid">
                    {{uploadFileFormValidator.address_proof.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let addressProof of uploadedFileForm.address_proof">
                            <span class="file-tag mt-2">
                                {{addressProof.fileName}}&nbsp;
                                <span class="pointer"
                                      (click)="removeFile(LoanApplicationDocumentType.ADDRESS_PROOF,addressProof.fileId)">
                                &#10005;
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>

                <app-masked-aadhaar-info class="col-sm-12"
                                         *ngIf="uploadedFileForm.addressProofType === AddressProofType.aadhaar">
                </app-masked-aadhaar-info>
            </div>
        </div>

        <div>
            <p class="form-field-heading">Bank statements</p>
            <p>Statement of your savings bank account or principal business account updated until loan submission
                date</p>
            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #bank_statement name="bank_statement"
                               (change)="uploadDocument(LoanApplicationDocumentType.BANK_STATEMENT, $event)"
                               (click)="bank_statement.value= null" appAcceptFormats=".pdf" accept=".pdf"  toggleCamera="SecureFile">
                        <div class="file-browse">
                            <span class="file-browse-txt">Last {{uploadedFileForm.employeeType === EmployeeType.Salaried ? 3 : 6}}
                                months Bank statement(s)</span>
                            <span class="browse"><i class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.BANK_STATEMENT"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.bank.isInValid">
                    {{uploadFileFormValidator.bank.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let bankStatement of uploadedFileForm.bank">
            <span class="file-tag mt-2">
                {{bankStatement.fileName}}&nbsp;
                <span class="pointer"
                      (click)="removeFile(LoanApplicationDocumentType.BANK_STATEMENT,bankStatement.fileId)">
                &#10005;
                </span>
            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngIf="uploadedFileForm.employeeType===EmployeeType.Salaried">
            <p class="form-field-heading">Salary slip(s)</p>

            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #salary_slip name="salary_slip"
                               (change)="uploadDocument(LoanApplicationDocumentType.SALARY_SLIP, $event)"
                               (click)="salary_slip.value=null" appAcceptFormats=".jpg,.jpeg,.png" toggleCamera="SecureFile">
                        <div class="file-browse">
                            <span class="file-browse-txt">Upload your Salary slip for 3 months</span>
                            <span class="browse"><i class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.SALARY_SLIP"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.salary.isInValid">
                    {{uploadFileFormValidator.salary.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let salarySlip of uploadedFileForm.salary">
            <span class="file-tag mt-2">
                {{salarySlip.fileName}}&nbsp;
                <span class="pointer"
                      (click)="removeFile(LoanApplicationDocumentType.SALARY_SLIP,salarySlip.fileId)">
                &#10005;
                </span>
            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div>
            <p class="form-field-heading">ITR Statement</p>

            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #itr name="itr"
                               (change)="uploadDocument(LoanApplicationDocumentType.ITR, $event)"
                               (click)="itr.value=null" appAcceptFormats=".pdf" accept=".pdf" toggleCamera="SecureFile">
                        <div class="file-browse">
                            <span class="file-browse-txt">Upload your ITR / Form16 for last year</span>
                            <span class="browse"><i class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.ITR"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.itr.isInValid">
                    {{uploadFileFormValidator.itr.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let itrDocuments of uploadedFileForm.itr">
                         <span class="file-tag mt-2">{{itrDocuments.fileName}}&nbsp;
                            <span class="pointer"
                                  (click)="removeFile(LoanApplicationDocumentType.ITR,itrDocuments.fileId)">&#10005;
                            </span>
                        </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngIf="uploadedFileForm.employeeType===EmployeeType.SelfEmployed">
            <p class="form-field-heading">Other Documents</p>
            <p>If you have uploaded the bank statement of your Principal business account, Please upload here a GST
                registration form or any similar document establishing the relationship between you and your
                business</p>
            <div class="row form2">
                <div class="col-sm-12">
                    <div class="file-placeholder">
                        <input type="file" class="fileUpload" #other name="other"
                               (change)="uploadDocument(LoanApplicationDocumentType.OTHER_DOCUMENT, $event)"
                               (click)="other.value=null" appAcceptFormats=".jpg,.jpeg,.png"  toggleCamera="SecureFile">
                        <div class="file-browse">
                            <span class="file-browse-txt">Upload relevant document</span>
                            <span class="browse"><i class="material-icons">file_upload</i></span>
                        </div>
                    </div>
                </div>
                <mat-spinner [diameter]="35" class="col-sm-4"
                             *ngIf="spinner.isVisible && spinner.target===LoanApplicationDocumentType.OTHER_DOCUMENT"></mat-spinner>
                <mat-error class="col-sm-12 error" *ngIf="uploadFileFormValidator.other_document.isInValid">
                    {{uploadFileFormValidator.other_document.error}}
                </mat-error>
                <div class="col-sm-12">
                    <ul class="file-list">
                        <li *ngFor="let otherDocument of uploadedFileForm.other_document">
            <span class="file-tag mt-2">
                {{otherDocument.fileName}}&nbsp;
                <span class="pointer"
                      (click)="removeFile(LoanApplicationDocumentType.OTHER_DOCUMENT,otherDocument.fileId)">
                &#10005;
                </span>
            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6">
                <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                    <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
                </button>
            </div>
            <div class="col-xs-6">
                <div class="pull-right">
                    <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading">NEXT
                    </app-forward-button>
                </div>
            </div>
        </div>
    </form>
</div>
